import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  isLoading: false,
  editSplashScreenData: {},
  error: {},
  isLoadingVideo: false, // Loading state for the main image
  isArabicVideoLoading: false, // Loading state for the Arabic image
  showPassword: false,
  videoBannerData: {},
  videoPreview: "",
  videoName: "",
  arabicVideoPreview: "",
  arabicVideoName: "",
  error: "",
  statusData: {},
  editDataLoading: false,
};

export const getSplashScreenEditData = createAsyncThunk(
  "/splash-screen/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/splash-screen/edit?splash_screen_id=${id}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const splashScreenSlice = createSlice({
  name: "splash",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSplashScreenEditData.pending, (state) => {
        // state.isLoading = true;
        state.error = null;
      })
      .addCase(getSplashScreenEditData.fulfilled, (state, action) => {
        state.editSplashScreenData = action.payload?.data;
      })
      .addCase(getSplashScreenEditData.rejected, (state, action) => {
        // state.isLoading = false;
        state.error = action.payload?.data;
      });
  },
});

export const { updateConfig } = splashScreenSlice.actions;
export default splashScreenSlice.reducer;
